import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { APIServerResponse, FaqCO } from 'src/app/shared/models/ApiModels';

import { GeneralService } from 'src/app/shared/services/general.service';


@Component({
  selector: 'app-home-faq',
  templateUrl: './home-faq.component.html',
  styleUrls: ['./home-faq.component.scss']
})
export class HomeFaqComponent {


  faqList:Array<FaqCO>;
  panelOpenState = false;
  // constructor(private router: Router, private genS: GeneralService){ }


  // ngOnInit() {
  //   this.getFaqList();
  // }

  // getFaqList()
  // {
    
  //   this.genS.getFaqList({status:'ACTIVE'}).subscribe((res: APIServerResponse) => {
  //     if(res.data)
  //     {
  //       this.faqList = res.data;
        
  //     }
  //   });
      
  // }
}
